export type ReleaseFlagStatus = "building" | "beta_test" | "released";

export interface ReleaseFlag {
  id: number;
  name: string;
  key: string;
  description: string;
  status: ReleaseFlagStatus;
  betaReleaseDate: string;
  generalAvailabilityDate: string;
}

export interface ReleaseFlagFormValues {
  name: string;
  key: string;
  description: string;
  status: ReleaseFlagStatus;
  betaReleaseDate: string;
  generalAvailabilityDate: string;
}

export const STATUS_LABELS: Record<ReleaseFlagStatus, string> = {
  building: "Building",
  beta_test: "Beta",
  released: "Released",
};

export const STATUS_OPTIONS: { label: string; value: ReleaseFlagStatus }[] = [
  { label: "Building", value: "building" },
  { label: "Beta", value: "beta_test" },
  { label: "Released", value: "released" },
];
